var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 59,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M17.473 1.159c-2.18 1.717-5.19 5.38-6.845 8.23-1.348 2.32-2.349 4.753-2.663 7.386-.534 4.49.687 8.667 2.663 12.696.162.33.357.479.78.479q6.006-.025 12.01 0c.416 0 .645-.105.79-.47.61-1.553 1.34-3.079 1.831-4.657.958-3.087 1.366-6.226.602-9.417-1.348-5.694-4.876-10.158-9.168-14.256z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13.8 16.819c-.009-1.95 1.67-3.638 3.622-3.619 1.926.02 3.56 1.659 3.578 3.581.009 1.95-1.678 3.638-3.621 3.619-1.918-.019-3.562-1.668-3.579-3.59zM8.135 15.419l-5.095 6.12v5.897l4.99-4.832s-.104-2.871-.104-3.974c0-1.102.209-3.204.209-3.204zM26.477 15.419l5.095 6.12v5.897l-4.991-4.832s.104-2.871.104-3.974c0-1.102-.208-3.204-.208-3.204z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M20.836 30.819v4.874l10.868 5.393v5.392M17.524 30.819v9.831l6.18 4.124v7.195M14.736 35.4 2.304 41.086v5.392"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.736 30.819v9.831l-6.172 4.124v7.195"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeMiterlimit: 10,
  d: "M2.304 52.15c.96 0 1.74-.73 1.74-1.63s-.78-1.63-1.74-1.63c-.961 0-1.74.73-1.74 1.63s.779 1.63 1.74 1.63ZM31.704 52.15c.96 0 1.74-.73 1.74-1.63s-.78-1.63-1.74-1.63c-.961 0-1.74.73-1.74 1.63s.779 1.63 1.74 1.63ZM8.564 57.632c.96 0 1.74-.73 1.74-1.63s-.78-1.63-1.74-1.63c-.961 0-1.74.73-1.74 1.63s.779 1.63 1.74 1.63ZM23.704 57.632c.96 0 1.74-.73 1.74-1.63s-.78-1.63-1.74-1.63-1.74.73-1.74 1.63.78 1.63 1.74 1.63Z"
})));
export { SvgRocket as ReactComponent };
export default __webpack_public_path__ + "dec3887bea434713c9ccd15d7eb8ab7c.svg";